import axios from "axios";
import React from "react";

//Material-ui core
import { Dialog, DialogActions, DialogContent, DialogTitle, TextField } from "@mui/material";

import Button from "../../../../components/CustomButtons/Button";
import GridContainer from "../../../../components/Grid/GridContainer";
import GridItem from "../../../../components/Grid/GridItem";
import TranslationWrapper from "../../../../components/TranslationWrapper/TranslationWrapper";

class Notificaties extends React.Component {
  constructor(props) {
    super(props);
    this.message = React.createRef();
  }

  state = {
    confirmationSend: false,
    readySend: false,
    deliverySend: false,
    openDialog: false,
  };

  canSendSms = () => {
    let customFields = this.props.bestelling.customFields;

    if (customFields === null || customFields === undefined) {
      return false;
    }

    let customFieldsJson = JSON.parse(customFields);

    return customFieldsJson.mobilenr !== undefined;
  };

  componentDidMount() {
    this.setSendState();
  }

  setSendState = () => {
    let bestelling = { ...this.props.bestelling };

    let confirmationSend = !(bestelling.orderNotificationSent === null || bestelling.orderNotificationSent === 0);
    let readySend = !(bestelling.orderReadySent === null || bestelling.orderReadySent === 0);
    let delivery = !(bestelling.orderOnDeliverySent === null || bestelling.orderOnDeliverySent === 0);

    this.setState({
      confirmationSend: confirmationSend,
      readySend: readySend,
      deliverySend: delivery,
    });
  };

  handleNotificatie = (type) => {
    let url = "/core/sentnotification/" + this.props.bestelling.id + "/" + this.props.bestelling.hash + "?type=" + type;

    axios
      .get(url, {
        baseURL: "",
      })
      .then((response) => {
        let newState = { ...this.state };
        newState[type + "Send"] = true;
        this.setState(newState);
      });
  };

  onClickButton = () => {
    this.setState({ openDialog: true });
  };

  onCloseDialog = () => {
    this.setState({ openDialog: false });
  };

  handleCustomNotificatie = (type) => {
    axios
      .post("sentnotification/" + this.props.bestelling.id + "/" + this.props.bestelling.hash + "?type=" + type, {
        message: this.message.current.value,
        baseURL: "",
      })
      .then((response) => {
        this.onCloseDialog();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  render() {
    return this.canSendSms() ? (
      <GridContainer>
        <GridItem md={4}>
          <TranslationWrapper tDefault={"Notificaties"} tKey={"bestellingen.modal.detail.notificaties.title"} />
        </GridItem>

        <GridItem align={"right"} md={8}>
          {!this.state.confirmationSend ? (
            <Button color={"info"} onClick={() => this.handleNotificatie("confirmation")} style={{ width: "33%" }}>
              <TranslationWrapper
                tDefault={"Bestelling ontvangen notificatie"}
                tKey={"bestellingen.modal.detail.notificaties.confirmationNotSend"}
              />
            </Button>
          ) : (
            <p>
              <TranslationWrapper
                tDefault={"Bestel bevestiging verzonden"}
                tKey={"bestellingen.modal.detail.notificaties.confirmationSend"}
              />
            </p>
          )}
          {!this.state.readySend ? (
            <Button color={"danger"} onClick={() => this.handleNotificatie("ready")} style={{ width: "33%" }}>
              <TranslationWrapper
                tDefault={"Bestelling klaar notificatie"}
                tKey={"bestellingen.modal.detail.notificaties.readyNotSend"}
              />
            </Button>
          ) : (
            <p>
              <TranslationWrapper
                tDefault={"Bestelling klaar verzonden"}
                tKey={"bestellingen.modal.detail.notificaties.readySend"}
              />
            </p>
          )}
          {!this.state.deliverySend ? (
            <Button color={"success"} onClick={() => this.handleNotificatie("delivery")} style={{ width: "33%" }}>
              <TranslationWrapper
                tDefault={"Bestelling onderweg notificatie"}
                tKey={"bestellingen.modal.detail.notificaties.deliveryNotSend"}
              />
            </Button>
          ) : (
            <p>
              <TranslationWrapper
                tDefault={"Bestelling onderweg verzonden"}
                tKey={"bestellingen.modal.detail.notificaties.deliverySend"}
              />
            </p>
          )}

          <>
            <Button color={"warning"} onClick={this.onClickButton} style={{ width: "33%" }}>
              <TranslationWrapper
                tDefault={"Custom notificatie"}
                tKey={"bestellingen.modal.detail.notificaties.customNotification"}
              />
            </Button>
            <Dialog onClose={this.onCloseDialog} open={this.state.openDialog}>
              <DialogTitle>
                <TranslationWrapper
                  tDefault={"Custom notificatie"}
                  tKey={"bestellingen.modal.detail.notificaties.customNotification"}
                />
              </DialogTitle>
              <DialogContent>
                <TextField
                  Controlled
                  autoFocus
                  fullWidth
                  id={"message"}
                  inputRef={this.message}
                  label={"Message"}
                  margin={"normal"}
                  multiline
                  placeholder={"Type your message here"}
                  type={"text"}
                  variant={"outlined"}
                />
              </DialogContent>
              <DialogActions>
                <Button color={"danger"} onClick={this.onCloseDialog} style={{ width: "100%" }}>
                  Cancel
                </Button>
                <Button
                  color={"success"}
                  onClick={() => this.handleCustomNotificatie("custom")}
                  style={{ width: "100%" }}
                >
                  Send
                </Button>
              </DialogActions>
            </Dialog>
          </>
        </GridItem>
      </GridContainer>
    ) : null;
  }
}

export default Notificaties;
